import { RoutesString } from 'common-modules/general/Config/routesString';

import './styled.scss';
import { useState, useRef, useEffect } from 'react';
import { dataSlide, moPremium, dataCalender, dataSlideResult } from 'data/generalOutline';
import { GetMobileStyledCompImg } from 'common-modules/general/Modules/functions';
import { observer } from 'mobx-react';
import MainModel from 'common-modules/general/Common/Logic/Main/MainSalesCommon';
import { toJS } from 'mobx';
import PageMoveText from 'common-modules/general/Common/Components/Button/PageMoveText';
import dayjs from 'dayjs';
import NewsSection from './NewsSection';

import { Swiper, SwiperSlide } from 'swiper/react';

interface Props {
  mainModel: MainModel;
}

/**
 * @Mobile
 * @description * 개요 페이지 컴포넌트
 *              * Props로 서버에서 가져온 기초 데이터 모델을 가져옵니다.
 */
const GeneralOutline = observer(({ mainModel }: Props) => {
  const isScheduledForSale = toJS(mainModel.mainData.data?.cdPrgsStat.includes('002')) || false;

  let currentIndexPre = 0;
  const premium = document.getElementById('handlePremium');
  let isDraggingPre = false;
  let startPosPre = 0;
  let currentTranslatePre = 0;
  let prevTranslatePre = 0;
  let animationIDPre;

  //   state switch
  const [isSwitch, setIsSwitch] = useState(false);
  const handleSwitch = () => {
    setIsSwitch(!isSwitch);
  };

  //  Handle modal
  const [isModal, setIsModal] = useState(false);

  // pop-up initial
  const popUp = useRef<any>(null);
  const popUpImg = useRef<any>(null);
  const openPopUp = (popUpName, img?: any) => {
    popUpName.current.style.visibility = 'visible';
    popUpName.current.style.opacity = 1;
    const body = document.body;

    body.style.overflow = 'hidden';
    if (img) {
      popUpImg.current.setAttribute('src', img);
    }
  };
  const closePopUp = popUpName => {
    popUpName.current.style.visibility = 'hidden';
    popUpName.current.style.opacity = 0;
    const body = document.body;

    body.style.overflow = '';
  };

  const salesInfo = toJS(mainModel.mainData.data);
  const newsSection = toJS(mainModel.mainData.data);

  // 220830 add
  interface contentList {
    name: string;
    isActive: boolean;
  }

  const contentList = [
    { name: '단지정보', isActive: true },
    { name: '세대정보', isActive: true },
    { name: '프리미엄', isActive: true },
    { name: '분양 일정', isActive: true },
    { name: '새소식', isActive: false }
  ];

  return (
    <div className="contents-general-outline-mobile">
      {/* 단지정보 */}
      {contentList[0].isActive ? (
      <div id="info" className="info">
        <div className="info-title">
          <h3>단지 정보</h3>
        </div>
        <div className="column-group">
          <div className="column">
            <div className="apt-info">
              <p className="tit">위치</p>
              <p className="txt">
                {/* <span className="address">{salesInfo?.addrBizLnd}</span> */}
                <span className="address">광주광역시 남구 봉선동 1143-36번지 일원</span>
              </p>
            </div>
          </div>
          <div className="column">
            <div className="apt-info">
              <p className="tit">대지면적</p>
              <p className="txt">
                <span className="address">{salesInfo?.infoGrndArea}</span>
              </p>
            </div>
          </div>
          <div className="column">
            <div className="apt-info">
              <p className="tit">규모</p>
              <p className="txt">
                <span className="address">{salesInfo?.infoCstScl}</span>
              </p>
            </div>
          </div>
          <div className="column">
            <div className="apt-info">
              <p className="tit">총 세대 수</p>
              <p className="txt">
                <span className="address">{salesInfo?.cntsNwbdHosh}</span>
              </p>
            </div>
          </div>
          <div className="column">
            <div className="apt-info">
              <p className="tit">주차대수</p>
              <p className="txt">
                {/* <span className="address">{salesInfo?.infoPklt}</span> */}
                <span className="address">총 717대(공동주택 705대 / 근생 12대)</span>
              </p>
            </div>
          </div>
          <div className="column">
            <div className="apt-info">
              <p className="tit">입주예정</p>
              <p className="txt">
                {/* <span className="address">
                  {salesInfo?.ipjuDate ? dayjs(salesInfo?.ipjuDate, 'YYYY년 MM월').format('YYYY년 MM월 예정') : '미정'}
                </span> */}
                <span className="address">
                2024년 10월
                </span>
              </p>
            </div>
          </div>
          <div className="column">
            <div className="apt-info">
              <p className="tit">주택전시관 오픈 일정</p>
              <p className="txt">
                {/* <span className="address">
                {salesInfo?.ipjuExhibDate ? dayjs(salesInfo?.ipjuExhibDate, 'YYYY년 MM월').format('YYYY년 MM월 예정') : '미정'}
                </span> */}
                <span className="address">
                2023년 03월 31일
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="info-caution">
          <span>* 상기 분양 계획은 변경, 지연 또는 취소될 수 있습니다.</span>
        </div>
      </div>
      ) : null}

      {/* 세대정보  */}
      {contentList[1].isActive ? (
      <div id="slide" className="slide">
        <div className="slide-container">
          <div className={`${isModal ? 'slide-modal' : 'modal-hidden'}`}>
            <div className="slide-modal-header">
              <div className="ico-question"></div>
              <div className="content">평 전환 기준</div>
              <div onClick={() => setIsModal(false)} className="icon-cancel"></div>
            </div>
            <div className="slide-modal-content">아파트는 공급면적, 오피스텔은 계약면적</div>
          </div>
          <div className="slide-container-header">
            <div className="slide-title">
              <a>
                <PageMoveText link={`#${RoutesString.SalesHousehold}`}>
                  <h3>세대 정보</h3>
                  <div className="arrow-right"></div>
                </PageMoveText>
              </a>
            </div>
            <div className="slide-info">
              <div className="slide-info-detail">
                <span>㎡ (전용면적)</span>
              </div>
              <div
                onClick={handleSwitch}
                style={{ background: `${isSwitch ? '#ff671d' : '#eee'}` }}
                className="slide-info-switch">
                <span style={{ left: `${isSwitch ? '50%' : '0'}` }} className="switch-icon"></span>
              </div>
              <div onClick={() => setIsModal(true)} className="slide-info-icon">
                <span className="mr-8">평</span>
                <div className="ico-question"></div>
              </div>
            </div>
          </div>
          <Swiper preventClicks={false} navigation={false} slidesPerView={1} spaceBetween={0}>
            {dataSlide.map((sp, index) => {
              return (
                <SwiperSlide key={index} className={`img${index} slide-items`} style={{ zIndex: dataSlide.length - index }}>
                  <div className="slide-items-img">
                    <img
                      onClick={() => {
                        openPopUp(popUp, `${sp.img}`);
                      }}
                      src={sp.img}
                      alt=""
                    />
                  </div>

                  <div className="slide-items-content" style={{ paddingTop: 15 }}>
                    <div className="content-title">
                      {isSwitch ? (
                        <div className="title">{sp.titleSwitchActive}</div>
                      ) : (
                        <div className="title">{sp.title}</div>
                      )}
                        <div className="subTitle">
                          {/* 총 {sp.total}실
                          <small>우선공급 {sp.subTitle}실, 일반분양 {sp.subTitle02}실</small> */} <small>{sp.subTitle}</small>
                        </div>
                    </div>
                    <div className="content-detail">
                      <span>{sp.detail}</span>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>

          <div className="slide-table">
            <table className="table-col">
              <colgroup>
                  <col style={{ width: '50%' }} />
                  <col style={{ width: '50%' }} />
              </colgroup>
              <thead>
                <tr>
                  <th className="border-b">분양 타입(㎡)</th>
                  <th className="border-b">세대 수</th>
                </tr>
              </thead>
              <tbody>
                {dataSlide.map((sp, index) => {
                  return (
                    <tr key={index}>
                      <td className="border-b">{isSwitch ? sp.titleSwitchActive : sp.title}</td>
                      <td>{sp.total}</td>
                      {/* <td>{sp.subTitle02}</td>
                      <td>{sp.total}</td> */}
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr className="bg-grey" data-type-result="data-type-result">
                  <td className="border-b">{dataSlideResult.title}</td>
                  <td className="border-b">{dataSlideResult.subTitle}</td>
                  {/* <td className="border-b">{dataSlideResult.subTitle02}</td>
                  <td className="border-b">{dataSlideResult.total}</td> */}
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      ) : null}

      {/* 프리미엄 */}
      {contentList[2].isActive ? (
      <div className="premium-info-mobile mt-15">
        {/* 좌우 간격을 0으로 하고 싶을 경우 slidesPerView 값을 1로 변경해 주세요 */}
        <Swiper preventClicks={false} navigation={false} slidesPerView={1.1} spaceBetween={10}>
          {moPremium.map((sp, index) => {
            return (
              <SwiperSlide key={index} className={`premium-items`} style={{ maxWidth: window.innerWidth - 30 }}>
                <div className="premium-items-bg">
                  <img src={sp.moImg} alt="" />
                  <div className="text-area">
                    <div className="sub-title">{sp.subtit}</div>
                    <div className="title">{sp.tit}</div>
                    {/* <div className="detail">{sp.detail}</div> */}
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
      ) : null}

      {/* 분양 일정  */}
      {contentList[3].isActive ? (
      <div id="calender" className="calender">
        <div className="calender-container">
          <div className="calender-container-title">
            <a>
              <PageMoveText link={`#${RoutesString.SalesInfo}`}>
                <h3>분양 일정</h3> <div className="arrow-right"></div>
              </PageMoveText>
            </a>
          </div>
          <div className="calender-list">
            {dataCalender.map((sp, index) => {
              return (
                <div key={index} className="calender-list-items">
                  <div className="calender-date">{sp.date}</div>
                  <div className="calender-info">{sp.detail}</div>
                </div>
              );
            })}
          </div>
          <div className="caution">* 인허가에 따라 일정은 변경될 수 있습니다.</div>
        </div>
      </div>
      ) : null}

      {/* 새소식  */}
      {contentList[4].isActive ? (
      <div id="news" className="news">
        <div className="news-container">
          <div className="news-container-title">
              <PageMoveText link={`#${RoutesString.SalesNews}`}>
                <h3>새소식</h3> 
                <i className="arrow-right"></i>
              </PageMoveText>
          </div>

          <NewsSection newsSection={newsSection} />
        </div>
      </div>
      ) : null}

      <div ref={popUp} className="pop-up">
        <div className="pop-up-header">
          <img
            onClick={() => {
              closePopUp(popUp);
            }}
            className="btn-close"
            src={GetMobileStyledCompImg('common/ico_close02.png')}
            alt="icoClose02"
          />
        </div>
        <div>
          <div className="pop-up-img">
            <img ref={popUpImg} src="" alt="DL건설" />
          </div>
        </div>
      </div>
    </div>
  );
});

export default GeneralOutline;
